import apiRoutes from '@constants/apiRoutes';
import { APPLICATION_STORES, DataAccessProvider } from '@constants/constants';
import baseApi, { noAuthBaseApi } from '@services/api';

export interface FetchApplicationDetailsApiMap {
  code: number;
  message: string;
  data: {
    marketPlace: (typeof APPLICATION_STORES)[keyof typeof APPLICATION_STORES];
    appUrl: string;
    name: string;
    icon: string;
    developerName: string;
    rating: string;
    reviews: string;
    downloads: string;
  };
}

export interface RegisterUserApiMap {
  code: number;
  message: string;
  data: {
    id: string;
    status: string;
  };
}

export interface UserPreference {
  language: string;
}
export interface QueryParams {
  key: string;
  value: string;
}
export interface RegisterUserPayload {
  name: string;
  company: string;
  companyHQ?: string;
  email: string;
  monthlyMarketingSpend?: string;
  attributedChannel?: string;
  dealSource: string;
  userPreference: UserPreference;
  authorityConsentAccepted: boolean;
  termsOfServiceAccepted: boolean;
  newsletterOptIn: boolean;
  queryParams: QueryParams[];
}

export type AdminRegisterUserPayload = {
  accountName?: string;
  category: string;
  genre: string;
  secondaryGenre?: string | null;
  subGenre?: string | null;
  monthlyMarketingSpend: string;
  playStoreUrl?: string;
  appStoreUrl?: string;
  websiteUrl?: string;
  iapMargin?: number;
  iaaIdList?: string[];
  mmp: string;
  connectionDetails?: any;
  dealName?: string | null;
  userEmail: string;
  clientCode: string;
  refreshRequired: boolean;
  aggregatedCohortData?: (string | null)[][];
  startMonth?: string;
  benchmarkingEnabled?: boolean;
  pvxPocEmail?: string;
  pvxPocName?: string;
  pvxPocUser?: string;
  pipedriveDealId?: number;
};

const register = noAuthBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchApplicationDetails: builder.query<
      FetchApplicationDetailsApiMap,
      {
        store: (typeof APPLICATION_STORES)[keyof typeof APPLICATION_STORES];
        appUrl: string;
      }
    >({
      query: ({ store, appUrl }) => apiRoutes.applicationDetails(store, appUrl),
    }),

    registerUser: builder.mutation<RegisterUserApiMap, RegisterUserPayload>({
      query: (payload: RegisterUserPayload) => ({
        url: apiRoutes.userSignup,
        method: 'POST',
        body: payload,
      }),
    }),
  }),
});

const adminRegister = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    adminRegisterUser: builder.mutation<RegisterUserApiMap, AdminRegisterUserPayload>({
      query: (payload: AdminRegisterUserPayload) => ({
        url: apiRoutes.adminRegisterUser,
        method: 'POST',
        body: {
          ...payload,
          refreshRequired: !(payload.mmp === DataAccessProvider.AGGREGATED_DATA),
        },
      }),
    }),
  }),
});

export const { useLazyFetchApplicationDetailsQuery, useRegisterUserMutation } = register;

export const { useAdminRegisterUserMutation } = adminRegister;
